import React from 'react';
import { connect } from 'dva';
import { Button, Carousel, Row, Col } from 'antd';
import Dimio, {DimioNotice} from '../../../components/Dimio';
import BaseComponent from '../../../components/BaseComponent';

import ImageGrid from '../../../components/ImageGrid';

//import Lightbox from 'react-images';
//import { Share, Like } from 'react-line-social';
import DimioModal from '../../../components/DimioModal';
import AboutTora from './AboutTora';

import moment from 'moment';
import config from '../config/config';
import _ from 'lodash';
import "../style/about.scss";

const KEY_DETAIL = 'detail';

class AboutPage extends BaseComponent {
/*
  constructor(props) {
    super(props);
  }
*/
  componentWillMount() {
    //const self = this;
    const {dispatch, appKey} = this.props;
//    console.info(appKey);

    this.load(config.about.getApi, {
      query: {},
      onSuccess(res){
        //self.setState({about: res.data});
        dispatch({
          type: 'about/setData',
          data: res.data
        });
      },
      onError(error){

      }
    });
  }

  render() {
    const {about} = this.props;
//    const imageOpt = {itemClass:'mb-2', hideGrid:true};
    const imageOpt = {itemClass:'mb-2'};
    const map = {
      'travel':'/themes/travel/dev/images/logo/afta-atas_menber-min.jpg',
      'school':'website/static/img/about/mara.png',
      'mobile':''
    };

    let item = null;
    if(about.services){
      item = _.find(about.services, {key: about.type});

      item.icon = (map[about.type])?map[about.type]:null;

      console.info(about.type, item);
    }

    const current = moment().format('HH:mm');

    const settings = {
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      variableWidth:true,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }]
    };

    return (
      <div className=''>
        <div className=''>
          <div className=''>
            <DimioNotice {...about} />

            {item &&
            <div className=''>
              <div className='section-sub-title'>{item.title}</div>
              <div className='row row-all-10'>
                <div className='mb-3 col-sm-4'>
                  <div className='row row-all-10'>
                    <div className='col-xs-6 col-sm-12'>
                      {item.icon &&
                      <img className='mb-3 border-1'
                           src={item.icon}
                           alt=""/>
                      }
                    </div>
                    {about.images.images &&
                    <div className='col-xs-6 col-sm-12 mb-5'>
                      <ImageGrid thumb='/themes/travel/dev/images/pct/office01.jpg'
                                 gallery={about.images.source}
                                 opt={imageOpt}/>
                      {/*
                      <img className='mb-3 border-1'
                           src="https://tora-tora.net/themes/travel/dev/images/pct/office01.jpg" alt=""
                           onClick={e => this.showModal(KEY_IMAGES)}
                      />
                      */}
                    </div>
                    }

                    <div className='current-time'>
                      シドニー現在時刻 <span>{current}</span>
                    </div>
                  </div>
                </div>
                <div className='mb-3 col-sm-8'>
                  <AboutTora {...about} item={item}/>
                </div>
              </div>

              <div className='row'>
                <div className='col-md-6 mx-auto'>
                  <Button className='btn btn-primary btn-block' onClick={e => this.showModal(KEY_DETAIL)}>
                    トラトラってどんなところ？
                  </Button>
                </div>
              </div>
            </div>
            }

            {item &&
            <DimioModal
              id={KEY_DETAIL}
              appKey={this.props.appKey}
              title='トラトラってどんなところ'
            >
              {item.title}
              <hr/>
              {item.intro}

              {item.about1}
              {about.images.images &&
              <Carousel {...settings}>
                {about.images.images.map(i => (
                  <div className=''><img src={i} alt=""/></div>
                ))}
              </Carousel>
            }
              {item.about2}
            </DimioModal>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ about }) => ({
  about
}))(AboutPage);


// WEBPACK FOOTER //
// ./src/pages/about/components/AboutPage.js